import { render, staticRenderFns } from "./OvertimePayApproval.vue?vue&type=template&id=79df66c6"
import script from "./OvertimePayApproval.vue?vue&type=script&lang=js"
export * from "./OvertimePayApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports